const style = `
  & .container-main {
    margin: calc(27.5vh - 7.5em) 20%;
    padding: 3em 3.5em;
  }
`

export default style
